export default __webpack_public_path__ + "static/media/rightvoting.052bc2c3.svg";